// CloseOnSelectDirective.js
export default {
	inserted(el, binding, vnode) {
		const selectComponent = vnode.componentInstance;
		if(selectComponent && selectComponent.$options.name === "v-select") {
			selectComponent.$on("input", () => {
				selectComponent.blur();
			});
		}
	}
};
